import { render } from "./toggle-switch.component.vue?vue&type=template&id=3eb10bd4&scoped=true&ts=true"
import script from "./toggle-switch.component.vue?vue&type=script&lang=ts"
export * from "./toggle-switch.component.vue?vue&type=script&lang=ts"

import "./toggle-switch.component.vue?vue&type=style&index=0&id=3eb10bd4&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb10bd4"]])

export default __exports__